<div class="handle-sidenav-menu w-full" >
  <div *ngIf="!showSearchInput" class="flex flex-row justify-between px-4 w-full h-full items-center bg-white border-t">

    <!-- Bouton Rechercher -->
    <button (click)="openSearchInput()"
      class="flex items-center gap-2 text-gray-700 hover:text-black font-medium">
      <i class="material-icons text-indigo-500">search</i>
      <span>Rechercher</span>
    </button>

    <!-- Bouton Mon Panier -->
    <button (click)="openBasket()"
      class="relative flex items-center gap-3 text-gray-800 font-semibold px-6 py-2">
      <i class="material-icons text-green-600">shopping_cart</i>

      <div class="text-left min-w-[100px]">
        <div class="text-sm leading-tight">Mon panier</div>
        <div class="text-sm text-gray-500">{{ totalPrice }}</div>
      </div>

      <span class="absolute -top-1 -right-1 bg-green-600 text-white text-xs px-1.5 rounded-full">
        {{ basketCount }}
      </span>
    </button>
  </div>

  <!-- Input search -->
  <div *ngIf="showSearchInput" class="flex items-center gap-3 px-4 py-2 bg-white border-t">
    <i class="material-icons cursor-pointer" (click)="setShowSearchInput(false)">close</i>

    <form [formGroup]="searchProductForm" class="flex-1 flex items-center gap-2">
      <input
        type="text"
        class="w-full rounded-xl border border-gray-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-indigo-500"
        placeholder="Rechercher un produit…"
        formControlName="searchProductInput"
        (input)="onSearchInputChange()"
      />
      <button type="button"
        class="rounded-xl px-3 py-2 text-sm border border-gray-200 bg-white hover:shadow"
        (click)="resetSearch()">
        Effacer
      </button>
    </form>
  </div>

  <div *ngIf="searchProductLoader" class="px-4 pb-2 bg-white">
    <div class="text-xs text-gray-500">Recherche…</div>
  </div>
</div>
